import SideBarActions from '@/view/sidebar/store-module/utility';
import State from '@/view/sidebar/store-module/interface';

const mutations = {
    [SideBarActions.SHOW_SIDEBAR]: (state: State) => {
        state.sideBarVisible = true;
    },
    [SideBarActions.HIDE_SIDEBAR]: (state: State) => {
        state.sideBarVisible = false;
    },
};

export default {
    mutations,
};
